export default {
  survey_result_cdc: [],
  immediate_measures: [],
  factors: [],
  attributes: [],
  root_causes: [],
  dealer_preventive_measures: [],
};
